"use client";

import { useEffect } from "react";

/**
 * Updates the <html lang> attribute when the locale changes during
 * client-side navigation. The root layout sets the initial lang on
 * the server, but since it doesn't re-render during locale switches,
 * this component keeps the attribute in sync.
 */
export function LocaleHtmlUpdater({ locale }: { locale: string }) {
  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  return null;
}
